

const About = () => {

	return (

		<div id="About" className="column-container gutter">
			<h3 className="center">About Me</h3>
				

			<div className="grid-paragraph-wrapper row-container">
				<quote className="center"> “I didn’t choose photography, photography chose me.”</quote>
			<div className="about-me-paragraph">
				<p>

					My name is <span className="name Audrey"> Jade Conradie </span>. I am a young, vibrant, enthusiastic photographer
					with a passion for capturing the beauty that life so easily offers. 
					I specialize in portrait, family and 
					couple shoots as well as events such as baby showers, birthday parties and so on.
				</p>
				<p>
					I firmly believe that the most effective way of catching the perfect
					moment on camera is creating a comfortable and friendly environment 
					with my clients.
				</p>
				<p>
					Contact me for the packages available, let me help capture the memories 
					that make life so beautiful.

				</p>
				
			</div>
			</div>
		</div>
	
	);

}

export default About;